import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { InputModule } from '../inputs';
import { PasswordComponent } from './components';
import { TranslateModule } from '../../core/translates';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,

        InputModule,
        TranslateModule,
    ],
    declarations: [
        PasswordComponent,
    ],
    exports: [
        PasswordComponent,
    ],
})

export class PasswordModule {}
